/**
 * Route for `hourly-data-widget-clicks-conversions-cr-epc-cost`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { HourlyDataWidgetClicksConversionsCrEpcCostPage } from "../features/hourly-data-widget-clicks-conversions-cr-epc-cost/HourlyDataWidgetClicksConversionsCrEpcCostPage";

export const hourlyDataWidgetClicksConversionsCrEpcCostRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/hourly-data-widget-clicks-conversions-cr-epc-cost",
	component: HourlyDataWidgetClicksConversionsCrEpcCostPage,
});

export default hourlyDataWidgetClicksConversionsCrEpcCostRoute;
